<template>
    <div class="item-count">
        {{ count }}
    </div>
</template>

<script>
export default {
    name: "CItemCount",

    props: {
        count: {

        }
    }
}
</script>

<style scoped>

.item-count {
    color: white;
    font-size: 12px;
    padding-right: 5px;
}

</style>